<template>
  <v-container
    fluid
    :class="`pa-0 container-player ${
      (isSafari || isIphone) && recordType === 'audio' ? 'text' : recordType ? recordType : 'default'
    }`"
    @click="onVideoClick"
    ref="containerFullScreen"
  >
    <a :href="pathnameInIframe" target="_blank">
      <v-row
        v-if="isInIframe"
        class="btn-watch-on-tape"
        :style="
          isInIframe
            ? isPlayerPause
              ? upHere
                ? 'position: fixed; transition: top 0.3s'
                : 'position: fixed; top: -50px; transition: top 0.3s'
              : 'position: fixed; transition: top 0.3s'
            : ''
        "
      >
        <div style="display: block; font-size: 15px; font-weight: 700; color: #eee">Watch on Tape</div>
      </v-row>
    </a>
    <v-row
      class="container-player-row"
      :style="videoContainerCss"
      ref="containerPlayerRow"
      no-gutters
      v-show="isExistFile || isFeedback"
      justify="center"
      align="center"
    >
      <v-col
        v-if="isInIframe"
        align="center"
        cols="auto"
        class="embeddable-title"
        :style="
          isInIframe
            ? isPlayerPause
              ? upHere
                ? 'position: fixed; transition: top 0.3s'
                : 'position: fixed; top: -70px; transition: top 0.3s'
              : 'position: fixed; transition: top 0.3s'
            : ''
        "
      >
        <div style="display: inline-block; vertical-align: top" class="mt-2 mr-3">
          <v-avatar
            v-if="this.currentClip.clipUploader"
            :color="
              !this.currentClip.clipUploader.userPicture
                ? this.currentClip.clipUploader.userDisplayName || this.currentClip.clipUploader.userFullName
                : '' | iconBackground
            "
            class="logo"
            round
            :size="25"
          >
            <div class="avatar-bg" v-if="this.currentClip.clipUploader.userPicture"></div>
            <span
              class="white--text text-h6 cent"
              style="font-size: 14px !important"
              v-if="!this.currentClip.clipUploader.userPicture"
            >
              {{
                this.currentClip.clipUploader.userDisplayName || this.currentClip.clipUploader.userFullName | iconFilter
              }}
            </span>
            <v-img :src="this.currentClip.clipUploader.userPicture" v-else />
          </v-avatar>
        </div>
        <div style="display: inline-block; text-align: left">
          <div style="display: block; font-weight: 700">
            {{ this.currentClip.clipTitle ? this.currentClip.clipTitle : 'Untitled' }}
          </div>
          <div style="display: block; font-size: 11px; font-weight: 400">
            {{ this.currentClip.clipUploader.userDisplayName || this.currentClip.clipUploader.userFullName }}
          </div>
        </div>
      </v-col>
      <v-col align="center" ref="containerBoxComment" class="container-contents" :cols="12">
        <box-comment
          ref="boxComment"
          v-if="!isPreview && this.currentClip.clipType !== 'audio'"
          :sectionIndex.sync="sectionIndex"
          :containerWidth.sync="containerWidth"
          :containerHeight.sync="containerHeight"
          :checked.sync="selectedCommentType"
          :seekTime="seekTime"
          :isShowBoxComment.sync="isShowBoxComment"
        ></box-comment>
        <div>
          <video
            type="video/mp4"
            ref="videoPlayer"
            :class="
              isInIframe
                ? 'video-js vjs-default-skin vjs-big-play-centered vjs-tape-theme vjs-iframe'
                : 'video-js vjs-default-skin vjs-big-play-centered vjs-tape-theme'
            "
            :preload="isMobile ? 'auto' : 'metadata'"
            :style="borderStyle"
            :poster="recordType === 'audio' ? (!isSafari && !isIphone ? audioBg : null) : null"
          ></video>
        </div>
        <!-- <select-comment-type v-if="!isFullScreen" @checked="checked"></select-comment-type> -->
        <!-- 영상이 멈췄을 경우 Play Button 추가 -->
        <v-container
          v-if="!isPreview && isScreen && isShowPlayBtn"
          @click="setControlbarPlay"
          class="container-loading pa-0"
          fluid
          fill-height
          :style="isInIframe ? 'position: fixed; top: 0; bottom: 0; z-index: 99 !important' : ''"
        >
          <v-row no-gutters justify="center" align="center">
            <v-icon class="btn-play" color="white" size="70">mdi-play</v-icon>
          </v-row>
        </v-container>

        <v-container
          v-if="!isPreview && isExistFile && isShowPlayBtn && $vuetify.breakpoint.width >= 960"
          no-gutters
          justify="center"
          align="center"
          class="wrap-container-playback-popup"
        >
          <v-card flat width="360" elevation="0" color="rgba(14, 21, 25, 0.66)" dark class="card-playback-popup py-3">
            <v-row no-gutters justify="center" align="center">
              <v-btn-toggle v-model="toggle_playback" class="btn-toggle" dark dense borderless>
                <v-btn
                  @click="playbackItem = item"
                  v-for="(item, index) in playbackItems"
                  :key="index"
                  dark
                  elevation="0"
                  class="btn-playback-popup"
                >
                  <span>x {{ item }}</span>
                </v-btn>
              </v-btn-toggle>
            </v-row>
            <v-row no-gutters justify="center" align="center" class="mt-3" style="height: 25px">
              <v-col
                cols="auto"
                :style="
                  convertClipDuration !== clipDurationRoundPlayback
                    ? 'text-decoration: line-through; color: #96a7af; font-size: 15px'
                    : 'font-size: 15px'
                "
              >
                {{ convertClipDuration }}
              </v-col>
              <v-col
                cols="auto"
                v-if="this.currentClip.clipDuration > this.currentClip.clipDuration / this.playback"
                class="mx-1"
              >
                <span class="material-icons-round icon-bolt" translate="no">bolt</span>
              </v-col>
              <v-col
                cols="auto"
                v-if="convertClipDuration !== clipDurationRoundPlayback"
                :class="
                  this.currentClip.clipDuration > this.currentClip.clipDuration / this.playback
                    ? 'fw-600'
                    : 'ml-3 fw-600'
                "
                style="font-size: 15px"
              >
                {{ clipDurationRoundPlayback }}
              </v-col>
            </v-row>
          </v-card>
        </v-container>

        <v-container
          v-if="sectionIndex === storeSectionIndex && isExistFile && (!loadedmetadata || !isVideoUploaded)"
          fluid
          fill-height
          class="container-loading-bg"
        >
          <!-- <v-container class="container-loading" fluid fill-height> -->
          <!-- blobUrl 이 만료되거나, clip이 업로드 중일 경우에 보여준다. -->
          <v-row v-if="!isVideoUploaded" no-gutters justify="center" align="center">
            <v-col class="mx-4" cols="12">
              <span v-html="videoUploadedTitle" class="video-not-uploaded" />
            </v-col>
            <v-col
              v-if="
                currentClip &&
                currentClip['clipUrl'] &&
                currentClip['clipUrl'] !== '' &&
                videoUploadedTitle.indexOf('Video Not Found')
              "
              class="mt-4"
              cols="12"
            >
              <v-btn
                :loading="isCheckVideoUploadedLoading"
                @click="checkVideoUploaded"
                color="#27cd8b"
                class="btn-video-upload-check"
              >
                {{ $t('videoUploadCheck') }}
              </v-btn>
            </v-col>
          </v-row>

          <!-- 클립은 있지만 업로드가 안되었을 경우 로딩바를 보여준다. -->
          <v-row v-else-if="!loadedmetadata" no-gutters justify="center" align="center">
            <v-progress-circular color="primary" height="50" indeterminate></v-progress-circular>
          </v-row>
        </v-container>
        <!-- </v-container> -->
      </v-col>
      <v-col
        class="container-video-controller"
        :style="
          (videoContainerCss,
          isInIframe
            ? isPlayerPause
              ? upHere
                ? 'position: fixed; bottom: 0px; left: 0; right: 0; transition: bottom 0.3s; z-index: 10001'
                : 'position: fixed; bottom: -140px; left: 0; right: 0; transition: bottom 0.3s; z-index: 10001'
              : 'position: fixed;  bottom: 0px; left: 0; right: 0; transition: bottom 0.3s; z-index: 10001'
            : '')
        "
        v-if="!options.controls && sectionIndex === storeSectionIndex"
        :cols="12"
        ref="containerControlbar"
      >
        <div
          v-if="isInIframe"
          class="btn-embeddable-comment"
          :style="hideComment ? 'background-color: rgba(48, 68, 78, 1)' : 'background-color: #289067'"
          @click="hideCommentEmit()"
        >
          <span class="material-icons-round mt-2" style="color: #eee; font-size: 18px">forum</span>
        </div>
        <div
          v-if="isInIframe"
          class="btn-embeddable-playList"
          :style="hidePlayList ? 'background-color: rgba(48, 68, 78, 1)' : 'background-color: #289067'"
          @click="hidePlayListEmit()"
        >
          <span class="material-icons-round" style="color: #eee; font-size: 22px; margin-top: 5px">view_carousel</span>
        </div>
        <video-control-bar
          :stIndex.sync="sectionIndex"
          :seekTime.sync="seekTime"
          class="controlbar"
          @selectSubTitle="selectSubTitle"
          @setShowCaption="setShowCaption"
          @setFullScreen="setFullScreen"
          @setSubTitles="setSubTitles"
          @finishUploadSubtitle="finishUploadSubtitle"
          :upHere.sync="upHere"
          :hideComment.sync="hideComment"
          :style="isInIframe ? 'border-radius: 0 !important' : ''"
        ></video-control-bar>
      </v-col>
    </v-row>
    <v-container
      v-if="isExistFile && isFeedback"
      class="pa-0 container-player-feedback"
      fluid
      fill-height
      @click="closeFeedback()"
    >
      <feedback
        @playpause="playPause"
        @setSeeked="setSeeked"
        @feedbackPageEmoji="feedbackPageEmojiEmit"
        :allEmojiList.sync="allEmojiList"
        :localFeedbackEmoji.sync="localFeedbackEmoji"
      ></feedback>
    </v-container>
    <!-- 비디오 플레이어 외에 Template 을 보여준다. -->
    <v-container
      v-if="!isPreview && sectionIndex === storeSectionIndex && !isExistFile"
      class="component-template pa-0"
      fluid
      fill-height
    >
      <!-- FollowUp View -->
      <follow-up v-if="currentClip.clipType === 'willFollowUp' || currentClip.clipType === 'followUp'"></follow-up>
      <!-- TextClip View -->
      <text-clip v-if="currentClip.clipType === 'text'"></text-clip>
      <!-- Embed View -->
      <embed-clip v-if="currentClip.clipType === 'embed'"></embed-clip>
      <poll v-if="currentClip.clipType === 'poll'"></poll>
    </v-container>
  </v-container>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import audioBg from '@/assets/img/audio-bg-fill.png'
import { isIphone, isSafari, setFullScreen, setCancelFullScreen, chkFullScreen } from '@/common/lib/strLib'
import { watchedClip, publicWatchedClip } from '@/services/clipApi'
import { getSessionId } from '@/common/common'
import { mapState, mapGetters } from 'vuex'
import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
import { chkUploadedFile } from '@/services/api'
import VideoControlBar from '@/views/meeting/component/VideoControlBar'
import BoxComment from '@/views/meeting/component/BoxComment'
// import SelectCommentType from '@/views/meeting/component/SelectCommentType'
import FollowUp from '@/views/meeting/component/template/FollowUp'
import TextClip from '@/views/meeting/component/template/TextClip'
import EmbedClip from '@/views/meeting/component/template/EmbedClip'
import Poll from '@/views/meeting/component/template/Poll'
import Feedback from '@/views/meeting/component/template/Feedback'

export default {
  components: { VideoControlBar, BoxComment, FollowUp, TextClip, EmbedClip, Poll, Feedback },
  name: 'VideoPlayer',
  props: ['sectionIndex', 'options', 'isIntro', 'allEmojiList', 'localFeedbackEmoji', 'upHere'],
  data() {
    return {
      resizeObserver: null,

      audioBg: audioBg,
      textBg: '',
      audioPlayer: null,
      videoPlayer: null,
      isFirstPlay: true,
      recordType: null,
      playerClipIndex: 0,
      interval: null,
      subTitleInterval: null,
      loadedmetadata: false,
      // clip 이 s3 에 올라갔는지 여부
      isVideoUploaded: true,
      // 재시도 실행 count
      checkVideoUploadedCnt: 0,
      isCheckVideoUploadedLoading: false,
      isUserInputEntered: false,
      containerWidth: 0,
      containerHeight: 0,
      isShowPlayBtn: true,
      videoContainerCss: '',
      // isFeedback: false,
      pauseAutoNext: false,
      feedbackPageEmoji: [],
      hideComment: true,
      hidePlayList: true,
      selectedCommentType: 'dragtocomment',
      playbackItems: [0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0],
      playbackItem: this.$store.getters.playback,
      toggle_playback: null,
      computedVideoWidth: null,
    }
  },
  methods: {
    closeFeedback() {
      this.$store.dispatch('setIsFeedback', false)
    },
    onVideoResize() {
      // this.$emit('resize', this.$refs.videoPlayer.offsetHeight)
      // console.log('onResize', this.$refs.videoPlayer.offsetWidth)
      // console.log('onResize 2222', this.$refs.containerBoxComment.offsetWidth)
      if (this.$refs.containerBoxComment) {
        this.containerWidth = this.$refs.containerBoxComment.offsetWidth
        this.containerHeight = this.$refs.containerBoxComment.offsetHeight
      }
      this.computedVideoWidth = this.$refs.videoPlayer.offsetWidth
    },

    checked(val) {
      this.selectedCommentType = val
    },
    playPause(val) {
      if (val == 'play') {
        this.$store.dispatch('nextClip', true)
      }
    },
    hideCommentEmit() {
      if (!this.hidePlayList) {
        this.hidePlayList = true
        this.$emit('hidePlayList', this.hideComment)
      }
      this.hideComment = !this.hideComment
      this.$emit('hideComment', this.hideComment)
    },
    hidePlayListEmit() {
      if (!this.hideComment) {
        this.hideComment = true
        this.$emit('hideComment', this.hideComment)
      }
      this.hidePlayList = !this.hidePlayList
      this.$emit('hidePlayList', this.hidePlayList)
    },
    setSeeked(val) {
      if (val == 'end') {
        this.videoPlayer.currentTime(this.$store.getters.duration)
        this.$store.dispatch('setSeeked', this.$store.getters.duration)
        this.$store.dispatch('setTimeStampSeekTime', this.$store.getters.duration - 0.01)
        this.$store.dispatch('setIsRequestSetSeekTime', true)
      }
    },
    feedbackPageEmojiEmit(val) {
      this.feedbackPageEmoji = val
      this.$emit('feedbackPageEmoji', this.feedbackPageEmoji)
    },
    // upload 직후 작업
    finishUploadSubtitle(data) {
      let subtitleUrl = `https://file.tape.ooo/clip/${this.mtInfo.wsId}/${data.subtId}.vtt`

      let captionOption = {
        kind: 'captions',
        srclang: data.code,
        label: data.country,
        src: subtitleUrl,
      }
      const trackEl = this.videoPlayer.addRemoteTextTrack(captionOption, false)
      trackEl.addEventListener('load', function () {})
    },
    setControlbarPlay() {
      if (this.videoControlBarComponent) this.videoControlBarComponent.pauseAndResume()
      else {
        this.playerPauseAndResume()
      }
    },
    setFullScreen() {
      //full screen 버튼 클릭 시 박스 데이터 밸류 초기화
      this.boxCommentComponent.initBoxValue()

      // Video Player 일 경우
      if (this.isMobile) {
        // 아이폰일 경우
        if (this.isIphone) {
          if (this.isFullScreen) this.videoPlayer.exitFullscreen()
          else this.videoPlayer.requestFullscreen()
        }
        // 아이폰이 아닐 경우
        else {
          setFullScreen(this.$refs.videoPlayer)
        }
      } else {
        setFullScreen(this.$refs.containerFullScreen)
      }
    },

    setForceStop() {
      if (this.videoPlayer !== undefined && this.videoPlayer !== null && !this.videoPlayer.paused()) {
        let pausePromise = this.videoPlayer.pause()
        if (pausePromise !== undefined) pausePromise.then(() => {}).catch(() => {})
      }
    },
    async setWatchedClip() {
      try {
        let currentClip = this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex]
        let isAnonymousUser = this.userInfo === undefined || this.userInfo === null
        let watchedUser = isAnonymousUser ? currentClip.anonymousUser : currentClip.watchedUser
        let sessionId = getSessionId()
        let index
        let result
        let userInfo =
          this.userInfo !== undefined && this.userInfo !== null
            ? this.userInfo
            : { userDisplayName: 'Anonymous', userId: sessionId }
        if (watchedUser !== undefined && watchedUser !== null)
          index = watchedUser.findIndex((user) => user.userId === userInfo.userId)

        if (index === undefined || index < 0) {
          // 익명 사용자 Watched 등록
          if (isAnonymousUser) {
            result = await publicWatchedClip(
              this,
              this.mtInfo.wsId,
              this.mtInfo.mtId,
              this.currentClip.clipId,
              sessionId
            )
          } else {
            result = await watchedClip(this, this.mtInfo.wsId, this.mtInfo.mtId, this.currentClip.clipId)
            // TODO: getChannelUpdate가 여기서도 필요한가?
          }
          if (result) this.setLocalWatchedUser(userInfo, isAnonymousUser)
        }
      } catch (e) {
        console.log(e)
      }
    },
    setLocalWatchedUser(userInfo, isAnonymousUser) {
      if (isAnonymousUser) {
        let list = this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex].anonymousUser ?? []
        list.push(userInfo)
        this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex].anonymousUser = list
      } else {
        let list = this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex].watchedUser ?? []
        list.push(userInfo)
        this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex].watchedUser = list
      }

      this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex].isWatched = true
    },
    // Video 영역 클릭 시 section Index 추가
    onVideoClick() {
      if (!this.isPreview && this.loadedmetadata) {
        if (
          this.totalSectionList !== undefined &&
          this.totalSectionList !== null &&
          this.totalSectionList.length > 0 &&
          this.sectionIndex !== undefined &&
          this.sectionIndex !== null &&
          this.sectionIndex >= 0 &&
          this.playerClipIndex !== undefined &&
          this.playerClipIndex !== null &&
          this.playerClipIndex >= 0
        ) {
          let currentClip = this.totalSectionList[this.sectionIndex].clipList[this.playerClipIndex]
          this.$store.dispatch('changeCurrentClip', {
            clipIndex: this.playerClipIndex,
            sectionIndex: this.sectionIndex,
            currentClip: currentClip,
            timeStampSeekTime: 0,
          })
          localStorage.setItem('currentClip', JSON.stringify(currentClip))
        }
      }
    },

    async chkUploadedFile(clip) {
      let isFileUploaded = false
      try {
        let path = 'https://file.tape.ooo/'
        // mp4 체크
        // let key = `clip/${this.mtInfo.wsId}/${clip.clipId}.${clip.clipType === 'upload' ? 'mp4' : 'webm'}`
        let mp4Key = `clip/${this.mtInfo.wsId}/${clip.clipId}.mp4`
        let getCheckMp4Result = await chkUploadedFile(this, mp4Key)

        // 파일이 있으면 클립에 넣어주는 작업 추가
        if (getCheckMp4Result) {
          this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex].clipUrl = path + mp4Key
          this.currentClip.clipUrl = path + mp4Key
          isFileUploaded = true
        }
        // if (clipUrl.includes('.webm') && (this.isSafari || this.isIphone)) {
        //   this.isVideoUploaded = false
        // }
        // 파일이 없을 경우 webm 체크
        // Iphone 과 Safari 에서는 webm 재생이 불가하기 때문에 mp4 변환을 기다려준다.
        else if (!this.isSafari && !this.isIphone) {
          let webmKey = `clip/${this.mtInfo.wsId}/${clip.clipId}.webm`
          let getCheckWebmResult = await chkUploadedFile(this, webmKey)
          if (getCheckWebmResult) {
            this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex].clipUrl = path + webmKey
            this.currentClip.clipUrl = path + webmKey
            isFileUploaded = true
          }
        }
        return isFileUploaded
      } catch (e) {
        console.log(e)
      }
    },
    // video-control-bar 에서 자막 선택 시
    selectSubTitle(subtitleData) {
      if (this.videoPlayer && subtitleData) {
        var tracks = this.videoPlayer.textTracks()

        for (var i = 0; i < tracks.length; i++) {
          var track = tracks[i]
          // Find the English captions track and mark it as "showing".
          if (track.kind === 'captions' && track.language === subtitleData.code) {
            track.mode = 'showing'
          } else {
            track.mode = 'disabled'
          }
        }
      }
    },
    // 처음 Init 시 자막 목록 추가
    setSubTitles() {
      if (
        this.videoPlayer &&
        this.currentClip &&
        this.currentClip.subTitleData &&
        this.currentClip.subTitleData.length > 0
      ) {
        for (let subTitleData of this.currentClip.subTitleData) {
          let subtitleUrl = `https://file.tape.ooo/clip/${this.mtInfo.wsId}/${subTitleData.subtId}.vtt`

          let captionOption = {
            kind: 'captions',
            srclang: subTitleData.code,
            label: subTitleData.country,
            src: subtitleUrl,
          }
          const trackEl = this.videoPlayer.addRemoteTextTrack(captionOption, false)
          trackEl.addEventListener('load', function () {
            // your callback goes here
          })
        }
      }
    },
    async setReadyToPlay() {
      let clip
      // let retryCount = 0

      // 실제 영상을 재생할지, source 만 setting 해줄지 여부
      if (
        this.totalSectionList !== undefined &&
        this.totalSectionList !== null &&
        this.totalSectionList.length > 0 &&
        this.sectionIndex !== undefined &&
        this.sectionIndex !== null &&
        this.sectionIndex >= 0
      ) {
        let clipList = this.totalSectionList[this.sectionIndex].clipList
        if (clipList !== undefined && clipList !== null && clipList.length > 0) {
          clip = this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex]
        }
      }
      if (clip && clip !== '') {
        let clipUrl = clip['clipUrl']

        // 클립 Url 존재 여부 확인
        if (clipUrl && clipUrl !== '') {
          // 업로드 직후 Blob 을 갖고있는 클립은 blob으로 재생
          if (clipUrl.includes('blob:') && clip.blobType && clip.blobType !== '') {
            // blobUrl 이 사용 가능한지 확인
            let isAvailable = false
            try {
              let result = await fetch(clipUrl)
              if (result) isAvailable = result.status === 200
            } catch (error) {
              isAvailable = false
            }
            // blobUrl이 사용 가능하다면 blobUrl 로 재생
            if (isAvailable) this.playPreview(clip.clipUrl, clip.clipDuration, clip.blobType, clip.clipType)
            // blobUrl 이 사용 불가능 하다면, 아직 업로드 중이라 판단
            else {
              this.isVideoUploaded = false
            }
          }
          // 클립이 mp4 로 변환되기 전 webm 으로 남아있는 경우
          if (clipUrl.includes('.webm') || clipUrl.includes('.mp4')) {
            // // Iphone 과 Safari 에서는 webm 재생이 불가하기 때문에 mp4 변환을 기다려준다.
            if (clipUrl.includes('.webm') && (this.isSafari || this.isIphone)) {
              this.isVideoUploaded = false
            }
            // 비디오 시작 전 사전 작업
            this.preparingPlayVideo(clip)
          }
        }
        // 영상 재생이 아닐 경우 template 재생
        else if (
          clip['clipType'] !== 'audio' &&
          clip['clipType'] !== 'video' &&
          clip['clipType'] !== 'upload' &&
          clip['clipType'] !== 'face'
        ) {
          this.preparingPlayVideo(this.currentClip)
        }
        // clip url 이 안들어왔을 경우엔 오류 메세지를 보여준다.
        else {
          this.isVideoUploaded = false
        }
        // SeekBar 전체 길이를 적용해주기 위해 저장
        if (this.sectionIndex === this.storeSectionIndex && clip.clipDuration && clip.clipDuration !== null)
          this.$store.dispatch('setDuration', clip.clipDuration)
      }
    },
    preparingPlayVideo(clip) {
      this.recordType = clip.clipType
      if (this.isExistFile) {
        this.playVideo(clip)
      } else {
        // Player 가 아닐경우에 전체화면을 제거해준다.
        // 모바일
        if (this.isMobile) {
          // 아이폰일 경우
          if (this.isIphone) this.videoPlayer.exitFullscreen()
          // 아이폰이 아닐경우
          setCancelFullScreen(this.$refs.videoPlayer)
        }
        // 모바일이 아닐 경우
        else setCancelFullScreen(this.$refs.containerFullScreen)
        // this.playTemplate(clip)
        // 영상 재생 외에 다른 클립들도 watched 로그를 쌓아준다.
        this.setWatchedClip()
      }
    },
    // Video가 업로드가 되었는지 체크
    async checkVideoUploaded() {
      this.isCheckVideoUploadedLoading = true
      let isFileUploaded = await this.chkUploadedFile(this.currentClip)

      if (isFileUploaded) {
        let clipUrl = this.currentClip['clipUrl']
        if (clipUrl && clipUrl !== '' && (clipUrl.includes('.webm') || clipUrl.includes('.mp4'))) {
          this.isVideoUploaded = true
          this.loadedmetadata = true
          this.checkVideoUploadedCnt = 0
          this.preparingPlayVideo(this.currentClip)
        } else {
          this.checkVideoUploadedCnt += 1
        }
      } else {
        this.checkVideoUploadedCnt += 1
      }
      this.isCheckVideoUploadedLoading = false
    },
    // Intro 영상 재생
    async playIntro(url, poster, recordType) {
      this.recordType = recordType
      this.videoPlayer.src({
        src: url,
        type: 'video/mp4',
      })
      this.videoPlayer.poster = poster
    },
    // Preview 재생
    async playPreview(url, duration, fileType, recordType) {
      this.recordType = recordType
      if (duration) {
        this.videoPlayer.duration = function () {
          return duration // the amount of seconds of video
        }
      }
      this.videoPlayer.src({
        src: url,
        type: fileType,
      })
      this.videoPlayer.load()
    },

    async getVidDataOnMobile() {
      if (this.isMobile) {
        await this.videoPlayer.play()
        await this.videoPlayer.pause()
      }
    },
    // 일반 비디오 재생
    async playVideo(clip) {
      this.getVidDataOnMobile()
      if (this.videoPlayer !== null && !this.videoPlayer.paused()) this.videoPlayer.pause()
      if (clip && clip.clipUrl && clip.clipDuration) {
        if (clip.clipDuration) {
          this.videoPlayer.duration = function () {
            return clip.clipDuration // the amount of seconds of video
          }
        }
        this.videoPlayer.src({
          src: clip.clipUrl,
        })
        this.videoPlayer.load()

        if (!this.isFirstPlay) {
          this.videoPlayer.currentTime(this.timeStampSeekTime)
          this.$store.dispatch('setTimeStampSeekTime', 0)
        }
      }
    },
    setCaption() {
      if (!this.currentClip.subTitleData) return
      let subtitleDataAll = this.currentClip.subTitleData
      let subtitleData
      if (subtitleDataAll.length === 1) {
        subtitleData = subtitleDataAll[0]
      } else if (localStorage.getItem('ccCode')) {
        for (var i = 0; i < subtitleDataAll.length; i++) {
          if (subtitleDataAll[i].code === localStorage.getItem('ccCode')) {
            subtitleData = subtitleDataAll[i]
            break
          } else {
            subtitleData = subtitleDataAll[0]
          }
        }
      } else if (!localStorage.getItem('ccCode') && (navigator.language || navigator.userLanguage)) {
        if (navigator.language) {
          for (var j = 0; j < subtitleDataAll.length; j++) {
            if (navigator.language.includes(subtitleDataAll[j].code)) {
              subtitleData = subtitleDataAll[j]
              break
            } else {
              subtitleData = subtitleDataAll[0]
            }
          }
        } else if (navigator.userLanguage) {
          if (navigator.userLanguage) {
            for (var h = 0; h < subtitleDataAll.length; h++) {
              if (navigator.userLanguage.includes(subtitleDataAll[h].code)) {
                subtitleData = subtitleDataAll[h]
                break
              } else {
                subtitleData = subtitleDataAll[0]
              }
            }
          }
        }
      } else {
        subtitleData = subtitleDataAll[0]
      }

      if (this.videoPlayer && subtitleData) {
        var tracks = this.videoPlayer.textTracks()

        for (var k = 0; k < tracks.length; k++) {
          var track = tracks[k]
          // Find the English captions track and mark it as "showing".
          if (track.kind === 'captions' && track.language === subtitleData.code) {
            track.mode = 'showing'
          } else {
            track.mode = 'disabled'
          }
        }
      }
    },
    setShowCaption(val) {
      var tracks = this.videoPlayer.textTracks()
      if (val) {
        this.setCaption()
      } else {
        for (var j = 0; j < tracks.length; j++) {
          tracks[j].mode = 'disabled'
        }
      }
    },
    async playerPauseAndResume() {
      if (localStorage.getItem('cc') == 'true' || localStorage.getItem('cc') == true) {
        this.setCaption()
      }

      if (this.videoPlayer !== undefined && this.videoPlayer !== null && !this.isFirstPlay && !this.isPauseSeek) {
        if (this.videoPlayer.paused()) {
          let playPromise = this.videoPlayer.play()
          if (playPromise !== undefined) playPromise.then(() => {}).catch(() => {})
          if (this.isCurrentSection) this.isShowPlayBtn = false
        } else {
          let pausePromise = this.videoPlayer.pause()
          if (pausePromise !== undefined) pausePromise.then(() => {}).catch(() => {})
        }
      } else {
        this.$store.dispatch('setIsPauseSeek', false)
      }
    },
    // Thumbnail 캡쳐
    captureThumbnail() {
      setTimeout(() => {
        let canvas = document.createElement('canvas')
        let video = this.$refs.videoPlayer
        if (video !== undefined && video !== null) {
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight
          let ctx = canvas.getContext('2d')
          if (this.recordType === 'face') {
            ctx.save()
            ctx.beginPath()
            ctx.arc(video.videoWidth / 2, video.videoWidth / 2, video.videoWidth / 2, 0, Math.PI * 2, false)
            ctx.clip()
          }
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
          this.$emit('captureThumbnail', canvas.toDataURL('image/webp', 0.1))
        }
      }, 500)
    },
    setControlPlayerWithTrigger() {
      if (this.isPreview) this.captureThumbnail()
      else if (this.sectionIndex === this.storeSectionIndex) this.playerClipIndex = this.storeClipIndex

      if (!this.isFirstPlay && this.isCurrentSection && !this.isPauseSeek && !this.isPreview) {
        this.videoPlayer.play()
        if (this.isCurrentSection) this.isShowPlayBtn = false
      } else {
        this.setForceStop()
        this.isFirstPlay = false
        this.$store.dispatch('setIsPauseSeek', false)
      }
    },
    initPlayer() {
      if (this.isIphone) this.options.html5.nativeTextTracks = true
      if (this.isMobile) {
        this.options.html5.nativeControlsForTouch = true
      }
      if (this.videoPlayer === null) {
        this.videoPlayer = videojs(this.$refs.videoPlayer, this.options)

        this.videoPlayer.on('ready', () => {})
        this.videoPlayer.on('canplay', () => {})

        this.videoPlayer.on('play', () => {
          this.isFirstPlay = false
          if (!this.isPreview) {
            this.$store.dispatch('setIsPauseIcon', true)
          }
          if (this.isCurrentSection) this.setWatchedClip()
        })
        this.videoPlayer.on('pause', () => {
          if (!this.isPreview) this.$store.dispatch('setIsPauseIcon', false)
        })
        this.videoPlayer.on('ended', () => {
          if (!this.isPreview && !this.isInIframe) {
            this.currentClip.originType = this.currentClip.clipType
            // this.isFeedback = true
            // setTimeout(
            //   function () {
            //     this.isFeedback = false
            //   }.bind(this),
            //   3000
            // )
            this.$store.dispatch('setIsFeedback', true)
            if (this.pauseAutoNext == true) this.$store.dispatch('nextClip', true)
          }
          this.$store.dispatch('setIsPauseIcon', false)
        })
        this.videoPlayer.on('ratechange', () => {
          this.videoPlayer.defaultPlaybackRate(this.videoPlayer.playbackRate())
        })
        this.videoPlayer.on('timeupdate', () => {
          this.$store.dispatch('setSeekTime', this.videoPlayer.currentTime())
        })
        this.videoPlayer.on('seeking', () => {})
        this.videoPlayer.on('seeked', () => {
          this.$store.dispatch('setSeeked', this.videoPlayer.currentTime())
        })
        this.videoPlayer.on('loadedmetadata', () => {
          this.getVidDataOnMobile()
          this.loadedmetadata = true
          this.resize()
          this.setControlPlayerWithTrigger()
          this.setSubTitles(this.currentClip)
        })
        this.videoPlayer.on('error', () => {
          let error = this.videoPlayer.error()
          if (error !== undefined && error !== null) {
            const content = {
              component: Toast,
              props: {
                msg: this.$t('general.error'),
                // submsg: '',
              },
            }
            switch (error.code) {
              // Webm 재생 안됌.
              case 3:
                // (this, 'Error', this.$t('general.error'), 'error')
                this.$toast.error(content)
                break

              default:
                break
            }
          }
        })
        // 전체화면 - 일반화면 전환 Event
        this.videoPlayer.on('fullscreenchange', () => {})
        this.videoPlayer.extend

        window.addEventListener('resize', this.resize)

        if (this.playback !== undefined && this.playback !== null && this.playback >= 0 && !this.isPreview) {
          this.videoPlayer.defaultPlaybackRate(this.playback)
          this.videoPlayer.playbackRate(this.playback)
        }
        if (this.volume !== undefined && this.volume !== null && this.volume >= 0) {
          this.videoPlayer.volume(this.volume / 100)
        }
      }
      if (this.isMobile) {
        this.videoPlayer.tech(true).el().controls = false
      }
    },
    resize() {
      // fullscreen 변화 감지
      this.$store.dispatch('setIsFullScreen', chkFullScreen())
      if (this.$refs.containerBoxComment) {
        this.containerWidth = this.$refs.containerBoxComment.offsetWidth
        this.containerHeight = this.$refs.containerBoxComment.offsetHeight

        // ControlBar 높이를 구해온다.
        const controlbarHeight =
          this.$refs.containerControlbar && this.$refs.containerControlbar.offsetHeight
            ? this.$refs.containerControlbar.offsetHeight
            : 0
        let controlbarPosition = 'relative'
        let controlbarBottom = 'unset'

        let videoHorizontalPadding = 0
        let videoVerticalPadding = 0

        // 컨트롤바 높이가 존재하고, 0보다 크고 Full Screen 일 경우만
        if (controlbarHeight !== undefined && controlbarHeight !== null && controlbarHeight >= 0 && chkFullScreen()) {
          controlbarPosition = 'absolute'
          controlbarBottom = 0

          // Base 비율을 16:9로 정해둔다.
          const baseRatio = 16 / 9

          // Video Player가 들어갈 수 있는 영역의 최대 크기 계산
          let maxHeight = window.innerHeight - controlbarHeight
          let maxWidth = maxHeight * baseRatio

          // baseRatio에 맞춰 실제로 가능한 최대의 가로, 세로 길이를 계산
          let targetWidth = maxWidth > window.innerWidth ? window.innerWidth : maxWidth
          let targetHeight = targetWidth / baseRatio

          // 계산된 Video Player의 크기에 따라 Padding 계산
          videoHorizontalPadding = window.innerWidth - targetWidth
          videoVerticalPadding = window.innerHeight - controlbarHeight - targetHeight
        }

        this.videoContainerCss = {
          '--padding-horizontal': videoHorizontalPadding / 2 + 'px',
          '--padding-vertical': videoVerticalPadding / 2 + 'px',
          '--control-bar-position': controlbarPosition,
          '--control-bar-bottom': controlbarBottom,
        }
      }
    },
    keyEvent(e) {
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        // F : 전체화면
        if (!e.ctrlKey && !e.metaKey && e.keyCode === 70) {
          this.setFullScreen()
          e.preventDefault()
        }
      }
    },
    togglePlayback() {
      let playback = this.$store.getters.playback
      let toggle
      switch (playback) {
        case 0.5:
          toggle = 0
          break
        case 0.75:
          toggle = 1
          break
        case 1:
          toggle = 2
          break
        case 1.25:
          toggle = 3
          break
        case 1.5:
          toggle = 4
          break
        case 1.75:
          toggle = 5
          break
        case 2:
          toggle = 6
          break
        default:
          toggle = 2
          break
      }
      this.toggle_playback = toggle
    },
  },
  mounted() {
    if (localStorage.getItem('playback')) {
      this.playbackItem = Number(localStorage.getItem('playback'))
    }

    if (this.$refs.videoPlayer) {
      this.resizeObserver = new ResizeObserver(this.onVideoResize)
      this.resizeObserver.observe(this.$refs.videoPlayer)
    }

    this.initPlayer()
    this.setReadyToPlay()
    document.addEventListener('keydown', this.keyEvent)
    this.togglePlayback()

    if (localStorage.getItem('cc') == 'true' || localStorage.getItem('cc') == true) {
      this.setCaption()
    }

    // console.log(this.$refs.containerPlayerRow)
  },
  created() {
    this.$root.$refs[`VideoPlayer-${this.sectionIndex}`] = this
  },
  beforeDestroy() {
    this.resizeObserver.unobserve(this.$refs.videoPlayer)

    if (this.videoPlayer) {
      this.videoPlayer.dispose()
    }
    if (this.interval !== undefined && this.interval !== null) {
      clearInterval(this.interval)
      this.interval = null
    }
    if (this.subTitleInterval !== undefined && this.subTitleInterval !== null) {
      clearInterval(this.subTitleInterval)
      this.subTitleInterval = null
    }
    document.removeEventListener('keydown', this.keyEvent)
  },

  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.videoPlayer.$el)
  },
  computed: {
    convertClipDuration() {
      let seconds = this.currentClip.clipDuration
      let minutes = Math.floor(seconds / 60)
      let remainingSeconds = Math.floor(seconds % 60)
      let result
      if (remainingSeconds == 0) {
        result = minutes + ' min '
      } else {
        result = minutes + ' min ' + remainingSeconds + ' sec'
      }

      return result
    },
    clipDurationRoundPlayback() {
      let seconds = this.currentClip.clipDuration / this.playback
      let minutes = Math.floor(seconds / 60)
      let remainingSeconds = Math.floor(seconds % 60)
      let result
      if (remainingSeconds == 0) {
        result = minutes + ' min '
      } else {
        result = minutes + ' min ' + remainingSeconds + ' sec'
      }

      return result
    },
    boxCommentComponent() {
      return this.$root.$refs[`BoxComment-${this.sectionIndex}`]
    },

    videoUploadedTitle() {
      let title = ''
      let timeGap = (Date.now() - this.currentClip['clipUploadedAt']) / 1000
      let compareTime = 1800 // 60분으로 비교

      if (this.currentClip && this.currentClip['clipUrl'] && this.currentClip['clipUrl'] !== '') {
        if (this.checkVideoUploadedCnt && this.checkVideoUploadedCnt > 0) {
          title = this.$t('invalidVideo')
        } else if (timeGap >= compareTime) {
          title = this.$t('videoNotFound')
        } else {
          title = this.$t('videoNotUploaded')
        }
      } else {
        title = this.$t('videoNotFound')
      }

      return title
    },
    /**
     * Box Comment 는 Preview 가 아니고, Full Screen 이 아니고, Screen 혹은 Upload Clip 일 경우에만 작동
     */
    videoControlBarComponent() {
      return this.$root.$refs[`VideoControlBar-${this.sectionIndex}`]
    },

    isShowBoxComment() {
      //recordType face 추가
      return (
        !this.isFullScreen &&
        (this.recordType === 'screen' || this.recordType === 'upload' || this.recordType === 'face')
      )
    },
    isPauseIcon() {
      return this.$store.getters.isPauseIcon !== undefined && this.$store.getters.isPauseIcon !== null
        ? this.$store.getters.isPauseIcon
        : false
    },
    borderStyle() {
      return {
        '--borderRadius': this.isInIframe ? '0' : this.options.controls ? '20px' : '20px 20px 0px 0px',
        '--paddingBottom': 0,
      }
    },
    isShowVideoLoading() {
      return (
        this.sectionIndex === this.storeSectionIndex &&
        this.currentClip.clipId !== undefined &&
        (this.currentClip.clipUrl === undefined || this.currentClip.clipUrl === '')
      )
    },
    isMobile() {
      return isMobile()
    },
    isPreview() {
      return this.sectionIndex === undefined && !this.isIntro
    },
    isIphone() {
      return isIphone()
    },
    isSafari() {
      return isSafari()
    },
    isCurrentSection() {
      let isSection = false
      if (
        this.sectionIndex !== undefined &&
        this.sectionIndex !== null &&
        this.storeSectionIndex !== undefined &&
        this.storeSectionIndex !== null
      ) {
        isSection = Number(this.sectionIndex) === Number(this.storeSectionIndex)
      }
      return isSection
    },
    uploadClip() {
      return this.$store.getters.uploadClip
    },
    isScreen() {
      let result = this.isPreview
      if (this.totalSectionList && this.totalSectionList.length > 0) {
        let clipList = this.totalSectionList[this.sectionIndex] ? this.totalSectionList[this.sectionIndex].clipList : []
        if (clipList && clipList.length > 0) {
          let clip = this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex]
          if (clip) result = clip.clipType === 'screen' || clip.clipType === 'upload'
        }
      }
      return result
    },
    isExistFile() {
      let result = this.isPreview
      if (this.totalSectionList && this.totalSectionList !== null && this.totalSectionList.length > 0 && !result) {
        let clipList = this.totalSectionList[this.sectionIndex].clipList
        if (clipList !== undefined && clipList !== null && clipList.length > 0) {
          let clip = this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex]
          if (clip) {
            result =
              clip.clipType === 'screen' ||
              clip.clipType === 'face' ||
              clip.clipType === 'audio' ||
              clip.clipType === 'upload'
          }
        }
      }
      return result
    },
    isFullScreen() {
      return this.$store.getters.isFullScreen
    },
    ...mapState({
      currentClip: (state) => {
        return state.clip.currentClip
      },
      // 재생중인 Video의  현재 Seek Time
      seekTime: (state) => {
        return state.clip.seekTime
      },
      // Video 에 시간을 Setting
      timeStampSeekTime: (state) => {
        return state.clip.timeStampSeekTime
      },

      isPlayerPause: (state) => {
        return state.clip.isPlayerPause
      },
      storeClipIndex: (state) => {
        return state.clip.clipIndex
      },
      storeSectionIndex: (state) => {
        return state.clip.sectionIndex
      },
      totalSectionList: (state) => {
        return state.clip.totalSectionList
      },
      isRequestSetSeekTime: (state) => {
        return state.clip.isRequestSetSeekTime
      },
      isRequestFullScreen: (state) => {
        return state.clip.isRequestFullScreen
      },
      volume: (state) => {
        return state.clip.volume
      },
      playback: (state) => {
        return state.clip.playback
      },
      isPlayerForceStop: (state) => {
        return state.clip.isPlayerForceStop
      },
      userInfo: (state) => {
        return state.auth.userInfo
      },
      mtInfo: (state) => {
        return state.auth.currentMt
      },
      isPauseSeek: (state) => {
        return state.clip.isPauseSeek
      },
      isFeedback: (state) => {
        return state.clip.isFeedback
      },
    }),
    ...mapGetters([
      'isMtOrganizer',
      'isWsOwner',
      'isWsManager',
      'commentList',
      'seekTime',
      'clipIndex',
      'clipList',
      'totalSectionList',
      'controlbarIconList',
      'currentClip',
      'currentMt',
      'boxDrawn',
      'selectedCh',
    ]),
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
    pathnameInIframe() {
      return 'https://app.tape.ooo' + document.location.pathname
    },
  },
  watch: {
    isFullScreen(val) {
      // Mobile 일 경우 전체화면일때만 Native Controller 가 보여야하므로 넣어준다.
      if (this.isMobile) this.videoPlayer.tech(true).el().controls = val
    },
    isPlayerForceStop() {
      this.setForceStop()
    },
    isPlayerPause() {
      if (this.isCurrentSection) {
        this.playerPauseAndResume()
      }
    },
    currentClip: {
      immediate: true,
      handler(val) {
        // 영상 관련 변수 초기화
        this.loadedmetadata = false
        this.isVideoUploaded = true
        this.checkVideoUploadedCnt = 0
        // 클립이 아닐 경우 다음영상 재생 시 play를 멈춰준다.
        if (val && val['clipType'] !== 'clip') this.setForceStop()

        if (val && this.videoPlayer !== null) {
          this.setReadyToPlay(val)
        }
        // this.isFeedback = false
        this.$store.dispatch('setIsFeedback', false)
        this.pauseAutoNext = false
      },
    },
    storeSectionIndex(val) {
      this.isFirstPlay = false
      if (this.sectionIndex !== val) {
        let pausePromise = this.videoPlayer.pause()
        if (pausePromise !== undefined) pausePromise.then(() => {}).catch(() => {})
      }
    },
    // 현재 클립이 변하지 않았을 경우에 Time 만 세팅 해준다.
    isRequestSetSeekTime(isRequestSetSeekTime) {
      if (isRequestSetSeekTime && isRequestSetSeekTime !== null && this.isCurrentSection) {
        let timeStamp = 0
        if (this.timeStampSeekTime !== undefined && this.timeStampSeekTime !== null && !isNaN(this.timeStampSeekTime)) {
          timeStamp = this.timeStampSeekTime
        }

        this.videoPlayer.currentTime(timeStamp)
        this.$store.dispatch('setTimeStampSeekTime', 0)
        this.$store.dispatch('setIsRequestSetSeekTime', null)
        this.$store.dispatch('setSeeked', this.timeStampSeekTime)
      }
    },
    // 볼륨 설정
    volume(val) {
      if (val !== undefined && val !== null && val >= 0) this.videoPlayer.volume(val / 100)
      localStorage.setItem('volume', val)
    },
    // 배속 설정
    playback(val) {
      if (val && val !== null && val >= 0) {
        this.videoPlayer.defaultPlaybackRate(val)
        this.videoPlayer.playbackRate(val)
        this.$store.dispatch('setPlayback', val && val !== null ? parseFloat(val) : 0)
        this.togglePlayback()
        localStorage.setItem('playback', val)
      }
    },
    playbackItem(val) {
      if (val && val !== null && val >= 0) {
        this.videoPlayer.defaultPlaybackRate(val)
        this.videoPlayer.playbackRate(val)
        this.$store.dispatch('setPlayback', val && val !== null ? parseFloat(val) : 0)
        this.togglePlayback()
        localStorage.setItem('playback', val)
      }
    },
    uploadClip() {
      if (this.sectionIndex === this.storeSectionIndex) this.isFirstPlay = true
    },
  },
}
</script>

<style scoped>
.video-js {
  /* border-radius: var(--borderRadius); */
  padding-bottom: var(--paddingBottom);
  background: black !important;
}
.video-js >>> video {
  /* border-radius: var(--borderRadius); */
  background: black !important;
}
.video-js >>> .vjs-text-track-cue {
  inset: unset !important;
  bottom: 10px !important;
  height: unset !important;
}
.video-js >>> .vjs-text-track-cue div {
  display: inline-block !important;
  max-width: 85%;
  word-break: keep-all;
  border-radius: 5px;
}
.video-js >>> .vjs-text-track-display {
  bottom: 0px !important;
}
@media (max-width: 1263px) {
  .video-js {
    border-radius: 0 !important;
  }
  .video-js >>> video {
    border-radius: 0 !important;
  }
}

.video-js >>> .vjs-menu-content {
  overflow: hidden !important;
}

/* recordType 이 없을 경우 */
.default >>> .video-js video.vjs-tech {
  width: 0;
  height: 0;
  padding-bottom: 0;
}
.default >>> .video-js div.vjs-poster {
  width: 0;
  height: 0;
  background: black !important;
}
/* 얼굴 촬영 화면에서 보여줄 스타일시트 */
.face >>> .video-js video.vjs-tech {
  position: absolute;
  left: 50%;
  top: 50%;
  width: auto;
  height: calc(100% - 50px);
  border-radius: 100%;
  object-fit: cover;
  transform: translate(-50%, calc(-50%));
  padding-bottom: 0;
  background-color: black !important;
}
.face >>> .video-js div.vjs-poster {
  position: absolute;
  left: 50%;
  top: 50%;
  width: auto;
  height: calc(100% - 50px);
  border-radius: 100%;
  object-fit: cover;
  transform: translate(-50%, calc(-50%));
  background-color: black !important;
}
.audio >>> .video-js video.vjs-tech {
  position: absolute;
  left: 50%;
  top: 50%;
  width: auto;
  height: 10rem;
  transform: translate(-50%, calc(-50%));
  background-color: black !important;
  padding-bottom: 0;
}
.audio >>> .video-js div.vjs-poster {
  position: absolute;
  left: 50%;
  top: 50%;
  width: auto;
  height: 10rem;
  transform: translate(-50%, calc(-50%));
  background-color: black !important;
}
.face >>> .video-js {
  background: transparent;
}
.face {
  background: transparent;
}
.audio >>> .video-js {
  background: transparent;
}
.audio {
  background: transparent;
}
.default >>> .video-js {
  background: transparent;
}
.default {
  background: transparent;
}
.screen >>> .video-js div.vjs-poster {
  background-color: black !important;
}
.screen >>> .video-js video.vjs-tech {
  background-color: black !important;
}
.screen >>> .vjs-subs-caps-button {
  display: none;
}
.audio >>> .vjs-subs-caps-button {
  display: none;
}
.face >>> .vjs-subs-caps-button {
  display: none;
}
/**
  * Player MetaData Loading
*/
.container-loading-bg {
  top: 0;
  left: 0;
  background: #21343b;
  z-index: 4 !important;
  position: absolute;
}
.container-loading {
  top: 0;
  left: 0;
  background: #21343b;
  z-index: 4 !important;
  opacity: 0.7;
  position: absolute;
}
@media (max-width: 1263px) {
  .container-loading-bg {
    border-radius: 0;
  }
  .container-loading {
    border-radius: 0;
  }
}
.btn-play {
  cursor: pointer;
}
.component-template {
  z-index: 1 !important;
  position: relative;
  height: auto;
}
@media (max-width: 1263px) {
  .component-template {
    position: relative;
  }
}
.container-player-row {
  padding-left: var(--padding-horizontal);
  padding-right: var(--padding-horizontal);
  padding-top: var(--padding-vertical);
}
.container-contents {
  position: relative;
}
@-moz-document url-prefix() {
  .container-player-row {
    padding-top: 0 !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
.container-video-controller {
  position: var(--control-bar-position);
  bottom: var(--control-bar-bottom);
}
.video-not-uploaded {
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  color: white;
}
.btn-video-upload-check {
  border-radius: 20px;
  color: white;
}
.embeddable-title {
  z-index: 9999;
  top: 10px;
  left: 10px;
  background-color: rgba(48, 68, 78, 0.9);
  color: #eee;
  padding: 10px 20px !important;
  border-radius: 5px;
}
.btn-embeddable-comment {
  position: absolute;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  z-index: 9;
  top: -50px;
  left: 15px;
  cursor: pointer;
  background-color: rgba(48, 68, 78, 1);
  border: 1px solid #eee;
  text-align: center;
  transition: top 0.3s;
}
.btn-embeddable-playList {
  position: absolute;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  z-index: 9;
  top: -50px;
  left: 60px;
  cursor: pointer;
  background-color: rgba(48, 68, 78, 1);
  border: 1px solid #eee;
  text-align: center;
  transition: top 0.3s;
}
.btn-watch-on-tape {
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 9999;
  padding: 10px 20px;
  background-color: rgba(40, 144, 103, 0.8);
  border-radius: 20px;
}
.vjs-iframe {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.container-player-feedback {
  position: absolute;
  top: 0;
  aspect-ratio: 16 / 9;
  height: calc(100% - 83px);
  z-index: 199;
  background-color: rgba(0, 0, 0, 0.5);
}

.btn-toggle {
  background: transparent !important;
}
.btn-toggle >>> button {
  height: 30px !important;
  border-radius: 5px !important;
  background-color: rgba(14, 21, 25, 1) !important;
}
.btn-toggle >>> span {
  font-size: 13px !important;
  font-weight: 400 !important;
}
.btn-toggle >>> button.v-item--active {
  color: #27cd8b;
  outline: 1px solid #27cd8b !important;
  background-color: rgba(14, 21, 25, 1) !important;
}
.btn-toggle >>> button.v-item--active::before {
  opacity: 0;
}
.wrap-container-playback-popup {
  position: absolute;
  width: 390px;
  height: 115px;
  top: 50%;
  margin-top: 50px;
  left: 50%;
  margin-left: -195px;
  z-index: 4;
}
.card-playback-popup {
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.btn-playback-popup {
  min-width: 45px !important;
  padding: 0px !important;
  margin: 0 2px;
  border-radius: 5px;
}
.icon-bolt {
  color: #ffc107;
  font-size: 18px;
  top: 3px;
  position: relative;
}
.fw-600 {
  font-weight: 600;
}
@media (max-width: 1263px) {
  .btn-play {
    font-size: 55px !important;
  }
}
</style>
